<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  @for (address of data.addresses; track address) {
  <div class="address-wrapper">
    <address-block
      class="address-inner"
      [address]="address"
      (click)="select(address)"
    >
    </address-block>
  </div>
  }
</mat-dialog-content>
